import { createSlice } from '@reduxjs/toolkit';
import { addCrudCases } from '../../store/addCrudCases';
import { rapidContactThunks } from './rapidContactThunks';
import type { RapidContactState } from './rapidContactTypes';

const initialState: RapidContactState = {
  items: [],
  byId: {},
  currentItem: null,
  status: 'idle',
  error: null,
  totalCount: 0,
};

export const rapidContactSlice = createSlice({
  name: 'rapidContacts',
  initialState,
  reducers: {
    clearCurrentRapidContact(state) { state.currentItem = null; },
  },
  extraReducers: (builder) => {
    addCrudCases(builder, rapidContactThunks, (r) => r.rapidContactId);
  },
});

export const { clearCurrentRapidContact } = rapidContactSlice.actions;
export const rapidContactReducer = rapidContactSlice.reducer;
